import PropTypes from 'prop-types';
import { lifecycle, compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { Endpoints } from '../lib/LeanLinkService';
import { withFetch } from '../entities/Entity/containers';
import { StaffingCompanyGroupRecord } from '../entities/records';
import * as selectors from '../entities/StaffingCompanyGroup/selectors';

export default compose(
  withFetch(),
  lifecycle({
    componentWillMount() {
      this.props.fetch({ url: Endpoints.staffingCompanyGroup() })
        .then(data => this.setState({ currentStaffingCompanyGroupId: data.result.id }));
    },
  }),
  setPropTypes({
    currentStaffingCompanyGroupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect(
    (state, { currentStaffingCompanyGroupId }) => ({
      currentStaffingCompanyGroup: currentStaffingCompanyGroupId ?
        selectors.staffingCompanyGroupById(state, currentStaffingCompanyGroupId) : undefined,
    }),
  ),
  setPropTypes({ currentStaffingCompanyGroup: PropTypes.instanceOf(StaffingCompanyGroupRecord) }),
);
